import { initAnalytics } from './analytics/analytics';
import { initRealUserMonitoring } from './realUserMonitoring/realUserMonitoring';
import { getAnalyticsConsent, getGdprApplies, readPublisherConsentCookie, updateGdprApplies } from './init.utils';
import { getPageURL } from './pageURL/pageURL';
import { markPerformance } from './performance/index';
import { ErrorReporter } from './errorReporter.type';

export interface StateAnalyticsParams {
  category: string | null;
  articleAuthor?: string;
  articleTitle?: string;
  articlePublicationTime?: string;
  siteName?: string;
  property?: string;
  countryCode: string;
  articleContentCount?: { [key: string]: number };
  articleWordCount?: number;
  language: string;
  pageType: string;
  articleId?: string;
  articleTemplate?: Array<string>;
  channels?: Array<string>;
  contentTags?: Array<string>;
  mainMedia?: string;
  commercialTags?: Array<string>;
  dfpProperty?: string;
  ABTestGroups?: Array<string>;
}

export interface ClientParams {
  platform: string;
  trafficSource: string;
  trafficSourceAndId: string;
  trafficId: string;
  mmUserIdentifier: string;
}

export type CoreParams = StateAnalyticsParams;

const pageURL = getPageURL();
const monitoringEndpoint = 'https://rum.minutemediaservices.com/';

export const createAnalyticsParams = ({
  category,
  articleAuthor,
  articleTitle,
  articlePublicationTime,
  siteName,
  property,
  countryCode,
  articleContentCount,
  articleWordCount,
  trafficId,
  language,
  pageType,
  articleId,
  articleTemplate,
  channels,
  contentTags,
  mainMedia,
  commercialTags,
  dfpProperty,
  platform,
  trafficSource,
  trafficSourceAndId,
  mmUserIdentifier,
  ABTestGroups,
}: StateAnalyticsParams & ClientParams) => ({
  pageIdentifier: category,
  geoDetected: countryCode,
  analyticsConsent: getAnalyticsConsent(readPublisherConsentCookie()),
  markupFormat: 'web',
  gdprApplies: getGdprApplies(),
  trafficReferrer: document.referrer,
  trafficId,
  articleAuthor,
  articleTitle,
  articlePublicationTime,
  siteName,
  property,
  articleContentCount,
  articleWordCount,
  language,
  platform,
  category,
  contentTags,
  pageType,
  test: pageURL.test,
  affiliateId: pageURL.affiliateId,
  articleId,
  articleTemplate,
  distributionChannels: channels,
  mmUserIdentifier,
  trafficSource,
  trafficSourceAndId,
  mainMedia,
  commercialTags,
  dfpProperty,
  ABTestGroups,
});

export function init(params: CoreParams & ClientParams, errorProvider: ErrorReporter) {
  const { pageType, countryCode } = params;

  initRealUserMonitoring(countryCode, pageType, monitoringEndpoint, errorProvider);

  try {
    initAnalytics(createAnalyticsParams(params));
    markPerformance('init-analytics');
  } catch (e) {
    errorProvider.reportException(e);
  }
  try {
    updateGdprApplies();
  } catch (e) {
    errorProvider.reportException(e);
  }
}
